import router from './router'
import store from './store'
import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css'// Progress 进度条样式
import { Message } from 'element-ui'
import { getToken } from '@/utils/auth' // 验权
import { setSupport, getSupport, setCookie, getCookie,removeCookie } from '@/utils/support';

const whiteList = ['/login', '/license'] // 不重定向白名单
router.beforeEach((to, from, next) => {
  let params = window.location.href.split('shopUser=')[1]
  if (params) {
    removeCookie('loginToken')
    let shopUser = JSON.parse(decodeURI(params))
    setCookie("shopUser", shopUser);
    window.location.href = window.location.origin
  }

  NProgress.start()

  if (getToken()) {
    if (to.path === '/login' || to.path === '/license') {
      next({ path: '/' })
      NProgress.done() // if current page is dashboard will not trigger	afterEach hook, so manually handle it
    } else {
      if (store.getters.roles.length === 0) {
        store.dispatch('GetInfo').then(res => { // 拉取用户信息
          // console.log('res.data',res.data.data)
          // 权限setCookie
          setCookie("is_purchase", res.data.data.is_purchase);
          setCookie("is_secondary", res.data.data.is_secondary);
          setCookie("is_sale", res.data.data.is_sale);
          setCookie("is_fico", res.data.data.is_fico);
          setCookie("grouping", res.data.data.grouping);
          setCookie("is_main", res.data.data.is_main);
          setCookie("eChartType", res.data.data.type);
          setCookie("subuser_id", res.data.data.subuser_id);
          setCookie("is_check_cart_all", res.data.data.is_check_cart_all);
          setCookie("company_name", res.data.data.company_name);
          setCookie("salelistfunc", res.data.data.salelistfunc);
          setCookie("partner_id", res.data.data.partner_id);
          setCookie("serveAppletsPopup", res.data.data.popup);
          setCookie("is_secondary", res.data.data.is_secondary);
          setCookie("user_name", res.data.data.user_name);
          setCookie("brand_grouping",res.data.data.brand_grouping);


          let menus = res.data.data.menus;
          // let menus=res.data.menus;
          // let username=res.data.username;
          let username = res.data.data.nickname;
          store.dispatch('GenerateRoutes', { menus, username }).then((ress) => { // 生成可访问的路由表
            router.addRoutes(store.getters.addRouters); // 动态添加可访问路由表
            // 中途跳转逻辑
            // 当接口返回的路由中有活动路由并且从登录页进来 直接跳转到活动页
            const isActivity = store.getters.addRouters.find(i => {
              if (i.meta && i.meta.title === '活动') {
                return true;
              }
            })
            if (isActivity && (to.path == '/' || to.path == '/home') && from.path == '/login') {
              next({ path: isActivity.redirect, replace: true })
              return;
            }
            // 中途跳转逻辑结束
            next({ ...to, replace: true })
          })
        }).catch((err) => {
          store.dispatch('FedLogOut').then(() => {
            Message.error(err || 'Verification failed, please login again')
            next({ path: '/' })
          })
        })
      } else {
        next()
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      next('/login')
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done() // 结束Progress
})



// WEBPACK FOOTER //
// ./src/permission.js